module.exports = __webpack_public_path__ + "static/media/note-0_5.d4fcd325.png";